import { Link } from 'react-router-dom-v5-compat';
import { UploadScanStatus } from 'src/types';
import { textStyleCss } from 'src/theme/atlas';
import { getScanStatusColor } from 'src/utils';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  display: flex;
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default;
  }};
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleDisplayMedium
      : textStyleCss(theme.atlas.typography.semantic.headingH3);
  }};
  font-size: 14px;
  align-items: center;
  text-decoration: none;
`;

export const ReportContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 85%;
  margin: 0 auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 8px;
    gap: 8px;
    max-width: 100%;
    margin: 0;
  }
`;

export const EvidenceList = styled.div`
  height: 100%;
  overflow: auto;
  overflow-wrap: anywhere;
  margin-top: 15px;
  padding-bottom: 15px;
  padding-right: 5px;

  @media (max-width: 768px) {
    height: 100%;
    margin: 20px 0;
    width: 340px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
  }
`;

export const Evidence = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: min-content;
`;

export const EvidenceVerticalLine = styled.div`
  border-left: 2px solid
    ${(props) => {
      const isVaultVariant = props.theme.isVaultVariant;
      return isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default;
    }};
  margin-left: 11px;
  flex-grow: 1;
`;

export const EvidenceIcon = styled.div<{ firstEvidence: boolean }>`
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  margin-left: 8px;
  justify-content: flex-start;
  // margin-top: ${(props) => (props.firstEvidence ? '25px' : '0')};

  & div {
    & div {
      height: 25px;
      width: 25px;
      color: white;
      background: black;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
  }
`;

export const EvidenceCard = styled.div<{ noPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 10px;
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default;
  }};
  width: 100%;
  line-height: 1.5;
  font-size: 12px;
  font-weight: 100;
  height: min-content;

  & h2 {
    ${({ theme }) => {
      const isVaultVariant = theme.isVaultVariant;
      return isVaultVariant
        ? theme.newTypography.textStyleBodySemibold
        : textStyleCss(theme.atlas.typography.semantic.bodySmall);
    }}
    font-weight: ${({ theme }) => (theme.isVaultVariant ? 'inherit' : '600')};
    margin-top: 0px;
  }

  & p {
    ${({ theme }) => {
      const isVaultVariant = theme.isVaultVariant;
      return isVaultVariant
        ? theme.newTypography.textStyleBody
        : textStyleCss(theme.atlas.typography.semantic.bodySmall);
    }}
    margin: 0;
    white-space: pre-line;
    padding-bottom: 20px;
  }

  & i {
    color: ${(props) => {
      const isVaultVariant = props.theme.isVaultVariant;
      return isVaultVariant
        ? props.theme.newPalette.neutral.N600
        : props.theme.atlas.semantic.color.type.muted;
    }};
  }
`;

export const UploadedEvidenceContainer = styled.div`
  width: 100%;
`;

export const EvidenceTitle = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.bodySmall);
  }};
  font-weight: ${({ theme }) => (theme.isVaultVariant ? 'inherit' : '600')};
  padding-bottom: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    padding-bottom: 0;
  }
`;

export const ReportTextEvidenceContainer = styled.div`
  width: 100%;
`;

export const EvidenceContent = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall);
  }};
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default;
  }};
  padding-bottom: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    padding-bottom: 0;
  }
`;

export const TableHeadingRow = styled.tr`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodySmallSemibold
      : textStyleCss(theme.atlas.typography.semantic.caption);
  }};
  font-weight: ${({ theme }) => (theme.isVaultVariant ? 'inherit' : '600')};
  text-transform: uppercase;
  padding-bottom: 13px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const TableRow = styled.tr<{ scanStatus: UploadScanStatus }>`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall);
  }};
  padding-bottom: 13px;
  line-height: 30px;
  color: ${(props) => getScanStatusColor(props.scanStatus, props.theme)};
`;

export const TableCell = styled.td`
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const TableFileNameCellLink = styled.a<{
  scanStatus?: UploadScanStatus;
}>`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) => getScanStatusColor(props.scanStatus, props.theme)};
`;

export const FileNameText = styled.span<{ scanStatus: UploadScanStatus }>`
  color: ${(props) => getScanStatusColor(props.scanStatus, props.theme)};
`;

export const FilesTable = styled.table`
  width: 100%;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-collapse: collapse;
    padding-left: 0;
  }
`;

export const FlaggedFilesError = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall);
  }};
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.red.R300
      : props.theme.atlas.semantic.color.status.error.default;
  }};
  padding-bottom: 20px;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const FlaggedFilesMobileError = styled.div`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.bodySmall);
  }};
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.red.R300
      : props.theme.atlas.semantic.color.status.error.default;
  }};
  display: none;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: block;
  }
`;

export const StyledEventsTitle = styled.h4`
  margin-top: 4px;
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleDisplaySmall
      : textStyleCss(theme.atlas.typography.semantic.headingH3);
  }};
`;

export const StyledTabContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 16px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e0e0e0;
`;

export const StyledTab = styled.div<{
  $isActive: boolean;
  $isLast?: boolean;
}>`
  text-align: center;
  padding: 14px 0;
  background: ${(props) => (props.$isActive ? '#fff' : '#f0f1f3')};
  color: ${(props) => (props.$isActive ? '#222' : '#aaa')};
  font-weight: ${(props) => (props.$isActive ? 700 : 400)};
  border-right: ${(props) => (props.$isLast ? 'none' : '1px solid #e0e0e0')};
  cursor: ${(props) => (props.$isActive ? 'default' : 'pointer')};
  opacity: ${(props) => (props.$isActive ? 1 : 0.7)};
  transition: all 0.15s;
  pointer-events: ${(props) => (props.$isActive ? 'none' : 'auto')};
  user-select: none;
  text-decoration: none;
  flex: 1;
`;
